import { Form, Input } from 'antd'
import { useLingui } from '@lingui/react/macro'

import type { CSSProperties } from 'react'
import type { FormItemProps, Rule } from 'antd/lib/form'

export interface IFormItemEmailProps
  extends Pick<FormItemProps, 'label' | 'preserve'> {
  requiredOnly?: boolean
  disabled?: boolean
  onClickEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  inputClassName?: string
  readOnly?: boolean
  style?: CSSProperties
}

const FormItemEmail: React.FC<IFormItemEmailProps> = (props) => {
  const {
    requiredOnly,
    disabled,
    onClickEnter,
    inputClassName,
    readOnly,
    style,
    ...restFormItemProps
  } = props
  const { t } = useLingui()
  const rules: Rule[] = useMemo(() => {
    const result = [{ required: true, message: t`Please enter your Email` }]
    if (requiredOnly) {
      return result
    }
    return [
      ...result,
      {
        type: 'email',
        validateTrigger: 'onBlur',
        message: t`Invalid email format`,
      },
    ]
  }, [requiredOnly])

  return (
    <Form.Item
      {...restFormItemProps}
      name='email'
      required={false}
      validateTrigger={['onChange', 'onBlur']}
      rules={rules}
    >
      <Input
        style={style}
        readOnly={readOnly}
        className={tw`
          h-12 px-3
          ${inputClassName}
        `}
        placeholder={t`Email`}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onClickEnter?.(event)
          }
        }}
        disabled={disabled}
      />
    </Form.Item>
  )
}

export default FormItemEmail
